<template>
  <div class="bts-accounts-ui-signup" :class="`system--${systemId}`">
    <router-view/>
  </div>
</template>
<script>
import './assets/css/style.scss';

export default {
  computed: {
    systemId() {
      return this.$store.state.systemId;
    },
  },
  beforeMount() {
    // TODO: add system configuration here
  },
};
</script>
